import { render, staticRenderFns } from "./user-quick-add.vue?vue&type=template&id=6d30f450&"
import script from "./user-quick-add.vue?vue&type=script&lang=js&"
export * from "./user-quick-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports